"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _constants = require("../../button/constants");

var _context = require("../../context");

var _layout = require("../../layout");

var _link = require("../../link");

var _utils = require("../../utils");

var _PageHeaderLink = require("./PageHeaderLink");

var _core = require("@emotion/core");

var _excluded = ["children", "icon", "iconPosition", "wrapper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SpanRow = _layout.Row.withComponent('span', {
  target: "e1fwququ0"
});

var getWrapperComponent = function getWrapperComponent(tag) {
  return (0, _context.styledWithTheme)(_link.Link.withComponent(tag, {
    target: "e1fwququ1"
  }))(function (_ref) {
    var selectors = _ref.theme.selectors;
    return {
      border: "".concat(_constants.BORDER_WIDTH, "px solid transparent"),
      backgroundColor: selectors.color('neutral0'),
      display: 'block',
      fontWeight: selectors.fontWeight('regular'),
      height: '100%',
      textDecoration: 'none',
      outline: 'none',
      position: 'relative',
      ':hover': {
        backgroundColor: selectors.color('primary05'),
        borderColor: selectors.color('primary70'),
        textDecoration: 'none'
      },
      ':active': {
        borderColor: selectors.color('primary80')
      },
      ':focus': {
        outline: 'none',
        borderColor: selectors.color('primary80')
      },
      ':focus:before': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        outline: "".concat((0, _utils.px)(_constants.BORDER_WIDTH), " solid transparent"),
        outlineOffset: _constants.OUTLINE_OFFSET
      }
    };
  });
};

var PageHeaderDropdownLinkWithoutDocs = function PageHeaderDropdownLinkWithoutDocs(_ref2) {
  var children = _ref2.children,
      icon = _ref2.icon,
      _ref2$iconPosition = _ref2.iconPosition,
      iconPosition = _ref2$iconPosition === void 0 ? _link.LinkIconPosition.Leading : _ref2$iconPosition,
      _ref2$wrapper = _ref2.wrapper,
      wrapper = _ref2$wrapper === void 0 ? _link.Link : _ref2$wrapper,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var Wrapper = getWrapperComponent(wrapper);
  return (0, _core.jsx)(Wrapper, forwardedProps, (0, _core.jsx)(SpanRow, {
    alignItems: "center",
    gridGap: !!icon ? 'S100' : undefined,
    height: "100%",
    padding: [16, 24]
  }, !!icon && iconPosition === _link.LinkIconPosition.Leading && icon, !!children && children, !!icon && iconPosition === _link.LinkIconPosition.Trailing && icon));
};

var PageHeaderDropdownLinkStyled = PageHeaderDropdownLinkWithoutDocs;

PageHeaderDropdownLinkStyled.withComponent = function (tag) {
  var Wrapper = _link.Link.withComponent(tag, {
    target: "e1fwququ2"
  });

  Wrapper.defaultProps = _objectSpread({}, _link.Link.defaultProps);
  return function (props) {
    return (0, _core.jsx)(PageHeaderDropdownLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};

var PageHeaderDropdownLinkWithDocs = (0, _stencilReactDesc.describe)(PageHeaderDropdownLinkStyled).description('Link dropdown item for PageHeader.');
PageHeaderDropdownLinkWithDocs.propTypes = _objectSpread(_objectSpread({}, (0, _utils.omit)(_link.Link.describedPropTypes, ['iconVerticalAlign'])), (0, _utils.pick)(_PageHeaderLink.PageHeaderLink.describedPropTypes, ['children', 'icon']));
var PageHeaderDropdownLink = (0, _utils.withTestAttributes)({
  component: 'StencilReactPageHeaderDropdownLink'
})(PageHeaderDropdownLinkWithDocs);
exports.PageHeaderDropdownLink = PageHeaderDropdownLink;
PageHeaderDropdownLink.displayName = 'PageHeaderDropdownLink';